import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class GetSectionSummaryService {

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) { }

  getSectionSummary(xAxisUnit, period) {
    let sectionId = this.common.getSelectedSection().sectionId;

    // this.storeAuth.getSection().subscribe((value) => {
    //   if (!value) {
    //     this.sectionId = localStorage.getItem('gokuri.sectionId');
    //   } else {
    //     this.sectionId = value;
    //   }
    // });
    // this.storeUser.getUserId().subscribe((value) => {
    //   if (!value) {
    //     this.userId = localStorage.getItem('gokuri.userId');
    //   } else {
    //     this.userId = value;
    //   }
    // });

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    this.headers = this.headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    // tslint:disable-next-line:max-line-length
    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}/summary?xAxisUnit=${xAxisUnit}&period=${period}`, { headers: this.headers });
  }

}
